import React, { Suspense } from 'react';
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import Cookies from 'js-cookie';
import { BACKEND_API_URL } from "../data/constant";
import { styled } from '@mui/joy/styles';
import NavBar from '../component/navbar';
import Footer from '../component/footer';
import { useColorScheme } from '@mui/joy/styles';

// Lazy-loaded route components for code splitting.
// Each route becomes its own chunk — only loaded when the user navigates to it.
const WelcomePage = React.lazy(() => import("../page/main"));
const BlogPage = React.lazy(() => import('../page/blog'));
const QuestionPage = React.lazy(() => import("../component/questionpage"));
const SetUserName = React.lazy(() => import("../component/login"));
const Leaderboard = React.lazy(() => import("../component/leaderboard"));
const CollapsibleList = React.lazy(() => import("../component/collapsiblelist"));
const AboutUs = React.lazy(() => import("../page/about"));
const TierComparison = React.lazy(() => import("../component/proj"));
const CancelCheckout = React.lazy(() => import("../page/cancel"));
const CheckoutSuccess = React.lazy(() => import("../page/success"));
const Profile = React.lazy(() => import("../page/profile"));
const Lobby = React.lazy(() => import("../page/Lobby"));
const Room = React.lazy(() => import("../page/Room"));
const Match = React.lazy(() => import("../page/Match"));
const Plans = React.lazy(() => import("../page/Plans"));
const PrivacyPolicy = React.lazy(() => import("../page/PrivacyPolicy"));
const TermsOfService = React.lazy(() => import("../page/TermsOfService"));
const Contact = React.lazy(() => import("../page/Contact"));
const Authoring = React.lazy(() => import("../page/Authoring"));
const Marketplace = React.lazy(() => import("../page/Marketplace"));
const SimulatorLab = React.lazy(() => import("../page/SimulatorLab"));
const SimulatorDetail = React.lazy(() => import("../page/SimulatorDetail"));
const CustomLabs = React.lazy(() => import("../page/CustomLabs"));
const BlogPostDetail = React.lazy(() => import('../page/blogDetail'));
const LearningPathsList = React.lazy(() => import('../page/LearningPaths').then(m => ({ default: m.LearningPathsList })));
const LearningPathDetail = React.lazy(() => import('../page/LearningPaths').then(m => ({ default: m.LearningPathDetail })));
const VerifyCertificate = React.lazy(() => import('../page/Certificate').then(m => ({ default: m.VerifyCertificate })));
const AdminPanel = React.lazy(() => import('../page/AdminPanel'));
const AiLabGenerator = React.lazy(() => import('../page/AiLabGenerator'));
const AiLabDetail = React.lazy(() => import('../page/AiLabDetail'));
const AiLabShared = React.lazy(() => import('../page/AiLabShared'));
const InterviewAdmit = React.lazy(() => import('../page/InterviewAdmit'));
const InterviewReport = React.lazy(() => import('../page/InterviewReport'));
const InterviewSessions = React.lazy(() => import('../page/InterviewSessions'));


export default function MyRoutes() {
   const navigate = useNavigate()
  //  const location = useLocation();

  //  const handleNavigate = (route) => {
  //    // Use the navigate function to programmatically navigate to a different route
  //    navigate(route);

  //    // Access information about the current route from the location object
  //    console.log('Current pathname:', location.pathname);
  //  };
  const { mode, setMode } = useColorScheme();
  const StatRoot = styled('body', {
    name: 'JoyStat', // The component name
    slot: 'root', // The slot name
  })(({ theme }) => ({
    backgroundColor: mode == "light" ? "white" : "black", 
    color: theme.vars.palette.primary[500],
    height: "100%",
    width: "100%",
    // backgroundImage: mode == "light" ? `url(${bg_img})` : `url(${bg_img_ex})`,
    backgroundSize: 'cover', // Adjust as needed
    backgroundPosition: 'center', // Adjust as needed
  }));

 
  const navItem = [
    {
      text: "Practice",
      children: [
        { text: "Solo Lab" },
        { text: "Learning Paths" },
        { text: "Lab Rooms" },
        { text: "Match Labs" },
        { text: "Simulator Marketplace" },
      ],
    },
    { text: "Pricing Plan" },
    // Pro-only: AI features and authoring grouped under "Create"
    ...(Cookies.get('tier') === 'pro' ? [{
      text: "Create",
      children: [
        { text: "AI Lab Generator" },
        { text: "Interview Sessions" },
        { text: "Authoring" },
        { text: "Simulator Lab" },
      ],
    }] : []),
    {
      text: "Community",
      children: [
        { text: "Community Labs" },
        { text: "LeaderBoard" },
        { text: "Blog" },
        { text: "Join Discord" },
      ],
    },
    { text: "About" },
  ]
  function SetWebLink() {
    window.location.href = 'https://discord.gg/DRH4Cqcj7W';
    return <div></div>;
  }

  function Logout() {
    fetch(BACKEND_API_URL + 'logout')
      .then(response => {
        console.log(response)
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        // Use response.url to check the final URL after redirection
        return response.json(); // Assuming the response is in JSON format
      })
      .then(data => {
        // Handle the JSON data from the final response
        console.log(data);
        navigate("/");
      })
      .catch(error => {
        // Handle errors that occurred during the request or redirection
        console.error('Fetch error:', error);
      });
      return <div>You Have been logout</div>;
  }

  return (
    <StatRoot>
      <div className="app-shell">
        <header className="app-shell__header">
          <NavBar navItem={navItem} />
        </header>

        <main className="app-shell__main">
          <Suspense fallback={<div style={{textAlign: 'center', padding: '2rem'}}>Loading...</div>}>
          <Routes>
            {/* NOTE: paths here must mirror buildPath() in navbar.js
                ('/' + text.replace(/\s+/g, '_').toLowerCase()).
                Solo Lab -> /solo_lab, LeaderBoard -> /leaderboard,
                Join Discord -> /join_discord. Mixing cases causes the
                navbar links to 404 because React Router 6 is case-
                sensitive by default. The /practice_now route below
                is a legacy redirect — old bookmarks/links 301-equivalent
                to /solo-lab via the <Navigate> element. */}
            <Route path="/practice_now" element={<Navigate to="/solo-lab" replace />} />
            <Route path="/solo-lab" element={ < CollapsibleList />} />
            <Route path="/solo_lab" element={<Navigate to="/solo-lab" replace />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/about" element={<AboutUs />}/>
            <Route path="/blog" element={<BlogPage/>}/>
            <Route path="/join-discord" element={<SetWebLink />} />
            <Route path="/join_discord" element={<Navigate to="/join-discord" replace />} />
            {/* <Route path="/logout" element={<Logout />} /> */}
            <Route path="/" element={<WelcomePage />} />
            <Route path="/set-username" element={<SetUserName />} />
            <Route path="/set_username" element={<Navigate to="/set-username" replace />} />
            <Route path="/pricing-plan" element={<TierComparison />} />
            <Route path="/Pro" element={<Navigate to="/pricing-plan" replace />} />
            <Route path="/question/:id" element={<QuestionPage />} />
            <Route path="/cancel" element={<CancelCheckout />} />
            <Route path="/success" element={<CheckoutSuccess />} />
            <Route path="/profile" element={< Profile/>} />
            <Route path="/post/:id" element={<BlogPostDetail />} />
            <Route path="/lobby" element={<Lobby />} />
            <Route path="/lab-rooms" element={<Lobby />} />
            <Route path="/lab_rooms" element={<Navigate to="/lab-rooms" replace />} />
            <Route path="/room/:id" element={<Room />} />
            <Route path="/match-labs" element={<Match />} />
            <Route path="/match_labs" element={<Navigate to="/match-labs" replace />} />
            <Route path="/plans" element={<Plans />} />
            <Route path="/plans/:id" element={<Plans />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/authoring" element={<Authoring />} />
            <Route path="/simulator-marketplace" element={<Marketplace />} />
            <Route path="/simulator_marketplace" element={<Navigate to="/simulator-marketplace" replace />} />
            <Route path="/simulator-marketplace/:name" element={<SimulatorDetail />} />
            <Route path="/simulator-marketplace/:name" element={<Navigate to="/simulator-marketplace/:name" replace />} />
            <Route path="/simulator-lab" element={<SimulatorLab />} />
            <Route path="/simulator_lab" element={<Navigate to="/simulator-lab" replace />} />
            <Route path="/community-labs" element={<CustomLabs />} />
            <Route path="/community_labs" element={<Navigate to="/community-labs" replace />} />
            <Route path="/ai_lab_generator" element={<Navigate to="/ai-lab-generator" replace />} />
            <Route path="/learning-paths" element={<LearningPathsList />} />
            <Route path="/learning-paths/:slug" element={<LearningPathDetail />} />
            <Route path="/ai-lab-generator" element={<AiLabGenerator />} />
            <Route path="/ai-lab-generator/shared/:token" element={<AiLabShared />} />
            <Route path="/ai-lab-generator/:id" element={<AiLabDetail />} />
            <Route path="/interview/:code" element={<InterviewAdmit />} />
            <Route path="/interview-sessions" element={<InterviewSessions />} />
            <Route path="/interview/report/:sessionId" element={<InterviewReport />} />
            <Route path="/verify/:id" element={<VerifyCertificate />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
          </Suspense>
        </main>

        <Footer />
      </div>
    </StatRoot>
  );
}